<template>
  <span>
    <StatusQuotationGarantia v-if="userAreaIsGarantia" />
    <StatusQuotationAgro v-if="userAreaIsAgro" class="agro-quotation" />
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";
import StatusQuotationGarantia from "./StatusQuotationGarantia";
import StatusQuotationAgro from "./StatusQuotationAgro";

export default {
  components: {
    StatusQuotationGarantia,
    StatusQuotationAgro
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia", "userAreaIsAgro"])
  },
  created() {
    if (!this.userAreaIsGarantia && !this.userAreaIsAgro) {
      this.requestMyInfo();
    }
  },
  methods: {
    ...mapActions("me", ["requestMyInfo"])
  }
};
</script>
<style>
.agro-quotation {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  min-height: 600px;
}
</style>
